export const COL_TYPES = {
	IMG: "img",
	DATE: "date",
	BOOL: "bool",
	AMOUNT: "amount",
	BADGE: "badge",
	PASSWORD: "password",
	RELATION: "relation",
	OBJECT: "object",
	ACTION: "action",
	NUMBER: "number",
	STRING: "string",
	BOOLEAN: "boolean",
	ENUMERATION: "enumeration",
	FILE: "file",
	EXPORT: "export",
	CUSTOM: "custom",
};

export interface BadgeConfig {
	value: string;
	label: string;
	class: string;
}

export interface FieldConfig {
	name: string;
	label: string;
	sortable: boolean;
	filterable: boolean;
	type?: string;
	tdClass?: string;
	width?: string;
	sortField?: string;
	relation?: {
		collection: string;
		valueField: string;
		displayField: string | string[];
		filters?: string;
	};
	badge?: BadgeConfig[];
	renderHtml?: (item: any) => string;
}
